import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	title: {
		id: 'eoc.heartbeats.header.page-header',
		defaultMessage: 'Heartbeats',
		description: 'Page title.',
	},
});

export default messages;
